<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[700px]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Pause/Unpause Examination {{exam.examinationName}}</h5>
    <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="ChangePauseStatus()">
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Reason</label>
        <textarea class="form-control" [(ngModel)]="reason" name="reason"></textarea>
      </div>
      <button class="btn btn-primary btn-lg col-md-10" type="submit"> Pause/Unpause
      </button>
    </form>
  </div>
</div>